package dev.tonholo.s2c.website.worker

import com.varabyte.kobweb.worker.Attachments
import com.varabyte.kobweb.worker.WorkerContext
import org.w3c.dom.Worker
import kotlin.js.Json
import kotlin.js.json

class IconConvertWorker(override var onOutput: WorkerContext.(output: dev.tonholo.s2c.website.worker.ConversionOutput) -> Unit = {}) :
    com.varabyte.kobweb.worker.Worker<dev.tonholo.s2c.website.worker.ConversionInput, dev.tonholo.s2c.website.worker.ConversionOutput> {

    private val ioSerializer = dev.tonholo.s2c.website.worker.IconConvertWorkerFactory().createIOSerializer()

    private val worker = Worker("/_kobweb/workers/dev-tonholo-s2c-website-worker/s2c-converter.js").apply {
        onmessage = { e ->
            val json = e.data.unsafeCast<Json>()
            val outputDeserialized = try {
                ioSerializer.deserializeOutput(json["_output"] as String)
            } catch (e: Throwable) {
                console.warn(buildString {
                    append("Unable to deserialize output generated by worker, ignoring it.")
                    e.message?.let { append("\nException: $it") }
                })
                null
            }
            if (outputDeserialized != null) {
                val ctx = WorkerContext(Attachments.fromJson(json))
                ctx.onOutput(outputDeserialized)
            }
        }
    }

    override fun postInput(input: dev.tonholo.s2c.website.worker.ConversionInput, attachments: Attachments) {
        val inputSerialized = try {
            ioSerializer.serializeInput(input)
        } catch (e: Throwable) {
            console.warn(buildString {
                append("Unable to serialize argument when calling `IconConvertWorker.postInput(dev.tonholo.s2c.website.worker.ConversionInput)`, ignoring the call.")
                e.message?.let { append("\nException: $it") }
            })
            null
        }
        if (inputSerialized != null) {
            worker.postMessage(
                json("_input" to inputSerialized).add(attachments.toJson()),
                attachments.toValues()
            )
        }
    }

    override fun terminate() {
        worker.terminate()
    }
}